
import React from 'react';
import PortfolioGenerator from './PortfolioGenerator';

const Portfolio = () => {
  return (
    <div className="container py-6">
      <PortfolioGenerator />
    </div>
  );
};

export default Portfolio;
